import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtoshirdishingnapurcab() {



  const cardData =
  {
    keyword: 'Daund to Shani Shingnapur Cab Service',
    heading: 'Sanavi Travels: Daund to Shani Shingnapur Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Daund to Shirdi Cab Service, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and tourists traveling from Daund to the holy town of Shirdi. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures spacious seating, air-conditioning, and ample luggage space for a smooth and peaceful journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup in Daund and surrounding areas, covering major attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted Daund to Shirdi cab services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Shani Shingnapur with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shani Shingnapur Temple",
    "description": "Shani Shingnapur Temple is a world-famous shrine dedicated to Lord Shani, the deity associated with justice and karma. The temple is unique as it has no roof over the idol, symbolizing open faith and divine protection. Devotees believe Lord Shani safeguards the village from theft and misfortune."
  },
  {
    "title": "Shani Dev Idol (Swayambhu Shila)",
    "description": "The main attraction of Shani Shingnapur is the swayambhu (self-manifested) black stone idol of Lord Shani. The idol is worshipped with oil offerings, especially on Saturdays and Amavasya, attracting thousands of devotees seeking relief from planetary doshas."
  },
  {
    "title": "Open-Door Village",
    "description": "Shani Shingnapur is renowned worldwide for its houses without doors or locks. Villagers strongly believe that Lord Shani protects their homes, and theft is considered impossible here. This tradition makes the village a symbol of faith, trust, and devotion."
  },
  {
    "title": "Shani Shingnapur Corridor",
    "description": "The temple corridor provides organized access for devotees, ensuring smooth darshan even during peak days. It enhances the spiritual experience with improved facilities while maintaining the sanctity of the temple premises."
  },
  {
    "title": "Shani Shanti Pooja Area",
    "description": "This area is dedicated to special rituals and poojas performed to reduce the effects of Shani Dosha and Sade Sati. Devotees participate in oil abhishekam, Shani Shanti pooja, and homas under priest guidance."
  },
  {
    "title": "Shani Shingnapur Museum",
    "description": "The museum near the temple showcases the history, legends, and traditions of Lord Shani and the village. It offers visitors insight into the beliefs and cultural importance of Shani Shingnapur."
  },
  {
    "title": "Nearby Ahmednagar City",
    "description": "Ahmednagar city, located close to Shani Shingnapur, offers additional attractions like historical forts, museums, and local markets. Many visitors combine their temple visit with a short exploration of the city."
  },
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi, located nearby, is a major pilgrimage destination dedicated to Sai Baba. Devotees often plan a combined visit to Shani Shingnapur and Shirdi, believing it brings spiritual balance and blessings."
  },
  {
    "title": "Pravara River",
    "description": "The Pravara River flows near Shani Shingnapur and adds a peaceful natural element to the pilgrimage. Visitors often spend quiet moments by the river after temple darshan."
  },
  {
    "title": "Devotional Markets",
    "description": "Local markets around the temple sell oil, black clothes, rudraksha, and devotional items used in Shani worship. These markets add cultural vibrancy and support the local economy."
  }
]
,



"services": [
  {
    "name": "Daund to Shani Shingnapur Cab Service",
    "description": "Daund to Shani Shingnapur Cab Service offers a reliable and comfortable travel option for devotees visiting the famous Shani Temple. Well-maintained, air-conditioned cabs with clean interiors and spacious seating ensure a peaceful and fatigue-free journey. Experienced chauffeurs handle highway driving, traffic conditions, and temple-route navigation efficiently, ensuring timely pickups and safe arrivals. Ideal for families, senior citizens, and pilgrims, this service supports flexible schedules, darshan planning, and smooth end-to-end travel from Daund to Shani Shingnapur."
  },
  {
    "name": "Shani Shingnapur Cab from Daund",
    "description": "Shani Shingnapur Cab from Daund provides dependable cab services designed specifically for religious travelers and tourists. Comfortable AC vehicles with professional drivers ensure punctual departures and safe driving throughout the journey. Suitable for solo devotees, families, and groups, this service focuses on convenience, reliability, and a calm travel experience for temple darshan."
  },
  {
    "name": "AC Cab Daund to Shani",
    "description": "AC Cab Daund to Shani ensures a cool and relaxing ride, especially during warm weather and longer travel hours. Fully air-conditioned cabs with smooth suspension, comfortable seating, and ample legroom reduce travel fatigue. Skilled chauffeurs ensure safe driving and efficient route management, making this service ideal for devotees seeking comfort and peace of mind."
  },
  {
    "name": "Affordable Shani Cab",
    "description": "Affordable Shani Cab offers budget-friendly cab options for Daund to Shani Shingnapur travel without compromising on safety or comfort. Clean, air-conditioned vehicles with experienced drivers ensure a smooth journey at economical pricing. Ideal for families, pilgrims, and cost-conscious travelers looking for reliable temple travel."
  },
  {
    "name": "Chauffeur Driven Cab Shani",
    "description": "Chauffeur Driven Cab Shani provides a stress-free travel experience with professional drivers managing navigation, traffic, and timing. Comfortable AC cabs allow passengers to relax and focus on their religious visit. Especially suitable for elderly devotees and families, this service emphasizes safety, courteous service, and smooth travel."
  },
  {
    "name": "Best Cab Daund to Shani",
    "description": "Best Cab Daund to Shani delivers high-quality and dependable cab services with well-maintained vehicles and trained chauffeurs. Fully air-conditioned cabs ensure comfort during the entire trip, while professional drivers ensure punctual pickups and safe arrivals. Ideal for families, tourists, and regular devotees, this service focuses on reliability, comfort, and customer satisfaction."
  },
  {
    "name": "Religious Tour Cab",
    "description": "Religious Tour Cab is specially designed for temple visits and pilgrimage travel. The service offers comfortable AC cabs, experienced chauffeurs, and flexible itineraries for religious tours. Ideal for devotees visiting Shani Shingnapur and nearby temples, it ensures a peaceful, well-organized, and respectful travel experience."
  },
  {
    "name": "Temple Darshan Cab",
    "description": "Temple Darshan Cab provides dedicated cab services for devotees planning temple darshan with proper timing and convenience. Drivers are familiar with temple routes and schedules, ensuring smooth access and timely drop-offs. Comfortable air-conditioned cabs make this service suitable for families, elderly devotees, and group travelers."
  },
  {
    "name": "Family Cab Shani Shingnapur",
    "description": "Family Cab Shani Shingnapur is designed to make family travel safe, comfortable, and convenient. Spacious air-conditioned cabs with sufficient luggage space accommodate all family members easily. Professional chauffeurs ensure smooth driving and flexible travel plans, making it ideal for family temple visits from Daund."
  },
  {
    "name": "Tourist Cab Shani",
    "description": "Tourist Cab Shani offers organized cab services for tourists visiting Shani Shingnapur and nearby attractions. Comfortable AC cabs with knowledgeable chauffeurs ensure a pleasant and informative travel experience. Perfect for families, couples, and groups planning religious sightseeing and leisure travel."
  },
  {
    "name": "Online Cab Booking Daund",
    "description": "Online Cab Booking Daund allows customers to easily reserve cabs for Daund to Shani Shingnapur travel anytime. Users can choose cab type, pickup location, travel date, and trip preferences with quick confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure a safe, reliable, and convenient booking experience."
  },
  {
    "name": "One Day Trip Cab",
    "description": "One Day Trip Cab is ideal for devotees planning a same-day visit from Daund to Shani Shingnapur. Comfortable AC cabs with experienced drivers ensure efficient travel, timely darshan, and a relaxed return journey. Suitable for families, senior citizens, and short religious trips."
  },
  {
    "name": "Outstation Cab Daund",
    "description": "Outstation Cab Daund provides reliable long-distance cab services from Daund to Shani Shingnapur and other destinations. Well-maintained air-conditioned vehicles with professional chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Ideal for pilgrimages, family trips, and extended travel plans."
  },
  {
    "name": "Shani Temple Taxi",
    "description": "Shani Temple Taxi offers convenient and quick taxi services focused on temple visits and darshan schedules. Easily accessible cabs ensure smooth pickups and drop-offs near the temple area. Ideal for elderly devotees and families, this service provides comfortable vehicles and experienced drivers."
  },
  {
    "name": "Shani Travel Cab",
    "description": "Shani Travel Cab provides dedicated cab solutions for devotees and tourists traveling from Daund to Shani Shingnapur. Comfortable AC cabs with trained chauffeurs ensure smooth travel for darshan, sightseeing, and return journeys. This service emphasizes comfort, safety, flexibility, and a peaceful religious travel experience."
  }
],
"tableData": [
  ["Daund to Shani Shingnapur Cab Service", "Shani Shingnapur Cab from Daund"],
  ["AC Cab Daund to Shani", "Affordable Shani Cab"],
  ["Chauffeur Driven Cab Shani", "Best Cab Daund to Shani"],
  ["Religious Tour Cab", "Temple Darshan Cab"],
  ["Family Cab Shani Shingnapur", "Tourist Cab Shani"],
  ["Online Cab Booking Daund", "One Day Trip Cab"],
  ["Outstation Cab Daund", "Shani Temple Taxi"],
  ["Shani Travel Cab", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Daund to Shani Shingnapur Cab Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable cab services from Daund to Shani Shingnapur, ideal for pilgrimages, family trips, and outstation travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and relaxing journey from Daund to Shani Shingnapur."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Shani Shingnapur route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Daund to Shani Shingnapur cab bookings, inclusive of fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your Daund to Shani Shingnapur trip."
  },
  {
    "WhyChooseheading": "Flexible Cab Booking Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your Daund to Shani Shingnapur travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Shani Shingnapur cab services."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services from Daund to Shani Shingnapur?',
    answer: 'Yes, Sanavi Travels offers reliable cab services from Daund to Shani Shingnapur for comfortable and safe travel.'
  },
  {
    question: 'How can I book a cab from Daund to Shani Shingnapur?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for the Daund to Shani Shingnapur route?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for the journey from Daund to Shani Shingnapur.'
  },
  {
    question: 'Are drivers experienced on the Daund to Shani Shingnapur route?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with the Daund to Shani Shingnapur route for safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup point in Daund and drop-off in Shani Shingnapur as per your convenience.'
  },
  {
    question: 'Is the Daund to Shani Shingnapur cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services from Daund to Shani Shingnapur.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Shani Shingnapur trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh More',
    feedback: 'Booked a cab from Daund to Shani Shingnapur. Comfortable ride, timely pickup, and professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Patil',
    feedback: 'Excellent cab service to Shani Shingnapur. The vehicle was clean and the journey was smooth.',
    rating: 5
  }
];










































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Shani Shingnapur Cab Service - Sanavi Travels",
  "description": "Book AC and chauffeur-driven cabs from Daund to Shani Shingnapur with Sanavi Travels. Ideal for religious tours, temple darshan, one-day trips, family travel, outstation journeys, and comfortable tourist rides.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Daund to Shani Shingnapur Cab Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and chauffeur-driven cabs from Daund to Shani Shingnapur with Sanavi Travels. Perfect for religious tours, temple darshan, one-day trips, family travel, outstation journeys, and safe tourist rides."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtoshirdishingnapurcab;